import { Component, OnInit, ViewChild, ViewContainerRef, TemplateRef, Inject } from '@angular/core';

import { ReceberService } from '@app/services/receber.service';
import { ConsultasService } from '@app/services/consultas.service';
import { Receber, ReceberLista, ReceberListaFiltros } from '@app/models/receber.model';
import { ReceberQuitarDados } from './receber-quitar-dados';
import { DropdownMeilisearchComponent } from '@app/components/dropdown-meilisearch/dropdown-meilisearch.component';
import { Paginacao } from '@app/models/util/paginacao';
import debounce from '@app/utils/debounce';
import { CDSMask } from '@app/utils/cds-mask';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { IdDescricao } from '@app/models/util/id-descricao';
import { Baixa, BaixaFormaDePagamento } from '@app/models/baixa.model';
import { MovimentacaoService } from '@app/services/movimentacao.service';
import { UsuarioTipoService } from '@app/services/usuario-tipo.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ParticipanteService } from '@app/services/participante.service';
import { error } from 'console';

@Component({
  selector: 'app-receber-lista',
  templateUrl: 'receber-lista.component.html',
  styleUrls: ['receber-lista.component.scss']
})
export class ReceberListaComponent implements OnInit {

  paginacao: Paginacao = new Paginacao();
  cdsMask: CDSMask = new CDSMask();
  acessoAOutrasUnidades = false;
  filtros = new ReceberListaFiltros();

  @ViewChild('imprimirSelecionadosModal', { static: true }) imprimirSelecionadosModal: TemplateRef<any>;

  modalRef: BsModalRef;
  modalReceberId: number = 0;

  lstParticipante: Array<any> = [{}];
  lstUnidade: Array<any> = [{}];
  lstReceber: ReceberLista[];
  lstModal: ReceberLista[];
  lstContas: IdDescricao[];
  lstBanco: IdDescricao[];
  lstFormaDePagamento: IdDescricao[];
  formaDePagamento: BaixaFormaDePagamento;
  baixasLista: Baixa[];
  baixa: Baixa;
  lstRecibos: ReceberLista[] = new Array();
  lstRecibosTemp: ReceberLista[];
  lstRecibosBaixa: Baixa[] = new Array();
  lstParciais: ReceberLista[] = [];
  lstTipoDR: any[];
  lstErrosModal: string[];

  editarModalDados = new Receber();

  quitarModalDados = new ReceberLista();
  tipoOperacaoBaixaManual: 'QUITAR' | 'DESQUITAR'

  totalReceber = 0;
  totalRecebidas = 0;

  mapeamentoParciais: number;
  dataRecebimento: string;
  recebendo: boolean;
  totalSelecionados = 0;
  valorTotal = 0;
  pesquisando: boolean;
  editando: boolean;
  _debounce: any;
  _pesquisa: any;

  acessoOutrasUnidades: boolean;
  acessoNovoReceber: boolean;
  MovimentarTodosOsCaixas: boolean = false;

  constructor(
    private movimentacaoService: MovimentacaoService,
    private receberService: ReceberService,
    private consultasService: ConsultasService,
    private modalService: BsModalService,
    @Inject(ToastrService) public toastr: ToastrService,
    private usuarioTipoService: UsuarioTipoService,
    private participanteService: ParticipanteService
  ) {
    this.baixa = new Baixa();
    this.baixa.valor = 0;
    this.baixa.trocoContaId = null;
    this.lstFormaDePagamento = [];
    this.formaDePagamento = new BaixaFormaDePagamento();
    this.formaDePagamento.valor = this.baixa.valor;
    this.baixasLista = [];
    this.lstModal = [];
  }

  ngOnInit() {
    this.participanteService.verificaPermissaoUsuario(0, 'MovimentarTodosOsCaixas')
      .subscribe(data => {
        this.MovimentarTodosOsCaixas = data;
        this.consultasService.consultar('CONTA').subscribe((data) => (this.lstContas = data));
      },
      error => this.consultasService.consultar('CONTA_USUARIO').subscribe((data) => (this.lstContas = data))
    );
    this.lstUnidade.push({ Id: 0, Descricao: 'Sem filtro' });
    this.consultasService.consultar('UNIDADE_S_RATEIO').subscribe(data => this.lstUnidade.push(...data));
    this.consultasService.consultar('BANCO').subscribe((data) => (this.lstBanco = data));
    this.consultasService.consultar('FORMADEPAGAMENTO_D').subscribe((data) => (this.lstFormaDePagamento = data));
    this.consultasService.consultar('DR_R').subscribe(data => this.lstTipoDR = data);

    this.usuarioTipoService.verificaPermissaoUsuario().subscribe(
      (permissoes: any) =>{
        this.acessoOutrasUnidades = permissoes.find(x => x.Descricao == 'VisualizarOutrasUnidades').Selecionado;
        this.acessoNovoReceber = permissoes.find(x => x.Descricao == 'NovosLancamentos').Selecionado;
        if(this.acessoOutrasUnidades){
          this.filtros.UnidadeId = 0;
        }
        else{
          this.filtros.UnidadeId = Number(UtilitarioService.retornaUnidadeUsuario());
        }
        this.obterLista(this.filtros, 1);
      });
  }

  pesquisar() {
    this.obterLista(this.filtros, 1);
    this.paginacao.paginaAtual = 1;
    this.paginacao.itensPorPagina = 20;
    this.lstParciais = [];
  }

  obterLista(filtros: ReceberListaFiltros, pagina: number) {
    this.pesquisando = true;
    filtros.Pagina = pagina;

    if (!filtros.ParticipanteId) {
      filtros.ParticipanteId = 0;
    }

    this.receberService.obterLista(filtros).subscribe(data => {
      this.lstReceber = data.Dados;
      this.paginacao.totalDeItens = data.TotalDados;
      this.totalReceber = data.TotalReceber;
      this.totalRecebidas = data.TotalRecebidas;
      this.pesquisando = false;
    }, erro => {
      this.pesquisando = false;
      this.toastr.warning("Realize a pesquisa novamente.")
    });
    //() => this.pesquisando = false);
  }

  pesquisarParciais(index: number) {
    if (this.lstParciais.length !== 0 && this.lstParciais[0].Cliente === this.lstReceber[index].Cliente) {
      this.lstParciais = [];
    } else {
      this.mapeamentoParciais = index;
      this.lstParciais = [];
      this.receberService
        .obterParciais(this.lstReceber[index].Id)
        .toPromise()
        .then(
          (data) => {
            if (data.length === 0) {
              this.toastr.warning('Esse título não possui pagamentos parciais');
            } else {
              this.lstParciais = data;
              this.lstParciais.forEach((parcial) => {
                parcial.Cliente = this.lstReceber[index].Cliente;
                parcial.ProcessoId = this.lstReceber[index].ProcessoId;
                parcial.DemonstrativoDeResultado = this.lstReceber[index].DemonstrativoDeResultado;
              });
            }
          },
          () => (this.toastr.warning('Houve algum problema'))
        );
    }
  }

  abrirModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
  }

  gravarEdicao(){
    this.editando = true;
    const _receber = { ...this.editarModalDados };

    this.receberService.gravar(_receber)
      .toPromise().then(
        () => {
          this.fecharModal();
          this.pesquisar();
          this.editando = false;
        },
        (data: any) => {
          if (data.error) {
            this.lstErrosModal = data.error.errors;
          }
          this.editando = false;
        });
  }

  abrirEditarModal(receberId: number, template: TemplateRef<any>){
    this.receberService.obterPorId(receberId).subscribe(data => { 
      this.editarModalDados = data;
      this.editarModalDados.Emissao = data.Emissao.split('T')[0];
      this.editarModalDados.Vencimento = data.Vencimento.split('T')[0];
      this.lstParticipante = [{ Id: data.Participante.Id, Descricao:data.Participante.NomeFantasia }];
    });
    this.abrirModal(template);
  }

  abrirQuitarModal(tituloReceber: ReceberLista, template: TemplateRef<any>): void {
    this.tipoOperacaoBaixaManual = 'QUITAR';
    this.abrirModal(template);
    this.quitarModalDados.Id = tituloReceber.Id;
    this.quitarModalDados.DataRecebimento = (new Date()).toISOString();
    this.quitarModalDados.Historico = tituloReceber.Historico;
  }

  abrirDesquitarModal(tituloReceber: ReceberLista, template: TemplateRef<any>): void {
    this.tipoOperacaoBaixaManual = 'DESQUITAR';
    this.abrirModal(template);
    this.quitarModalDados.Id = tituloReceber.Id;
    this.quitarModalDados.DataRecebimento = null;
    this.quitarModalDados.Historico = tituloReceber.Historico;
  }

  concatenaHistorico(event: Event): void {
    this.quitarModalDados.Historico += (event.target as HTMLButtonElement).textContent;
    document.getElementById('historico').focus();
  }

  quitar() {
    const dadosQuitar = new ReceberQuitarDados(
      this.quitarModalDados.Id,
      this.quitarModalDados.DataRecebimento.toString(),
      this.quitarModalDados.Historico
    );

    this.receberService.quitar(dadosQuitar).subscribe(
      (dados) => {
        this.toastr.success(`Título quitado.`, 'Sucesso');
        this.quitarModalDados = new ReceberLista();
      }, (erro) => {
        this.toastr.error(`Houve algum erro para quitar o título.`, 'Erro');
        console.warn(erro);
      }, () => {
        this.fecharModal();
      }
    );
  }

  desquitar() {
    const dadosQuitar = new ReceberQuitarDados(
      this.quitarModalDados.Id,
      '',
      this.quitarModalDados.Historico
    );

    this.receberService.desquitar(dadosQuitar).subscribe(
      (dados) => {
        this.toastr.success(`Título desquitado.`, 'Sucesso');
        this.quitarModalDados = new ReceberLista();
      }, (erro) => {
        this.toastr.error(`Houve algum erro para desquitar o título.`, 'Erro');
        console.warn(erro);
      }, () => {
        this.fecharModal();
      }
    );
  }

  cancelaQuitar() {
    this.fecharModal();
  }

  deletar(id: number) {
    this.receberService.deletar(id).subscribe((data) => {
      this.obterLista(this.filtros, 1);
    });
  }

  estorno(id: number) {
    this.receberService.realizarEstorno(id)
      .subscribe(
        () => {
          this.toastr.success('Estorno realizado com sucesso!');
          this.obterLista(this.filtros, 1);
          if (this.lstParciais.length !== 0) {
            this.lstParciais = this.lstParciais.filter((parcial) => parcial.Id !== id);
          }
        },
        (data: any) => {
          if (data.error) {
            let _erros = '';
            for (let i = 0; i < data.error.length; i++) {
              _erros = data.error.errors[i] + ' ';
            }
            this.toastr.error(_erros);
          }
        }
      );
  }

  public pageChanged(event: any): void {
    this.obterLista(this.filtros, event.page);
  }

  checkAll(e: Event) {
    const checked = (e.target as HTMLInputElement).checked;
    if (checked) {
      this.lstModal = [];
      this.lstReceber.forEach((receber) => {
        receber.checked = true;
        this.lstModal.push(receber);
      });
      this.totalSelecionados = this.lstModal.length;
    } else {
      this.lstReceber.forEach((receber) => {
        receber.checked = false;
      });
      this.lstModal = [];
      this.totalSelecionados = this.lstModal.length;
    }
  }

  onClick(index: number, e: Event) {
    const checked = (e.target as HTMLInputElement).checked;
    let lstTemp: ReceberLista[];
    lstTemp = this.lstModal.filter(({ Id }) =>
      Id === this.lstReceber[index].Id
    );

    if (checked) {
      if (lstTemp.length !== 0) {
        this.toastr.warning(
          'Esse titulo já está selecionado na sua lista');
        return;
      }
      this.lstModal.push(this.lstReceber[index]);
      this.totalSelecionados = this.lstModal.length;
    } else {
      this.lstModal.splice(this.lstModal.indexOf(this.lstReceber[index]), 1);
      this.totalSelecionados = this.lstModal.length;
    }
  }

  receberSelecionados(template: TemplateRef<any>) {
    if (this.lstModal.length > 0) {
      let valorRecebido = 0;
      valorRecebido = this.lstModal.reduce(
        (accumulator, currentValue) => accumulator + currentValue.ValorRecebido, 0);

      if (valorRecebido > 0) {
        this.toastr.warning('Algum título selecionado possui recebimentos parciais vinculados a ele, pague-o individualmente.');
      } else {
        // this.modalService.show(this.receberSelecionadosModal, Object.assign({}, { class: 'modal-lg modal-xl', id: 1 }));
        this.abrirModal(template);
        this.valorTotal = this.lstModal.reduce(
          (accumulator, currentValue) => accumulator + (currentValue.Valor - currentValue.ValorRecebido), 0);
      }
    } else {
      this.toastr.info('Selecione ao menos uma conta para pagar');
    }
  }


  fecharModal() {
    this.modalRef.hide();
    this.modalRef = null; 
    this.lstErrosModal = null;
  }
  fecharModalRecebimento() {
    this.modalService.hide(1);
    // this.receberSelecionadosModal.hide();
    this.totalSelecionados = this.lstModal.length;
  }

  receber(template: TemplateRef<any>) {
    const fpEncontrada = this.lstFormaDePagamento.find(
      (x) => x.Id === this.formaDePagamento.formaDePagamentoId
    );
    if (fpEncontrada) {
      this.formaDePagamento.formaDePagamentoDescricao = fpEncontrada.Descricao;
    }
    const contaEncontrada = this.lstContas.find(
      (x) => x.Id === this.formaDePagamento.contaId
    );
    if (contaEncontrada) {
      this.formaDePagamento.contaDescricao = contaEncontrada.Descricao;
    }

    if (this.lstModal.length <= 0) {
      this.toastr.error(
        'Selecione pelo menos uma conta para efetuar o recebimento'
      );
      this.recebendo = false;
      // this.receberSelecionadosModal.hide();
      this.modalService.hide(1);

    } else {
      if (this.dataRecebimento == null || this.dataRecebimento === '') {
        return this.toastr.error(
          'O campo "Data do Pagamento" precisa estar preenchido'
        );
      }
      if (this.formaDePagamento.formaDePagamentoId == null) {
        return this.toastr.error(
          'O campo "Forma de pagamento" precisa estar preenchido'
        );
      }
      if (this.formaDePagamento.contaId == null) {
        return this.toastr.error(
          'O campo "Conta/Caixa" precisa estar preenchido'
        );
      }

      this.recebendo = true;
      this.lstModal.forEach((item) => {

        const temp = JSON.parse(JSON.stringify(new Baixa()));
        item.DataRecebimento = this.dataRecebimento;
        temp.dataPagamento = this.dataRecebimento;
        temp.tipo = 'receber';
        temp.documentoId = item.Id;
        temp.valor = item.Valor;
        temp.formaDePagamento[0] = JSON.parse(JSON.stringify(this.formaDePagamento));
        temp.formaDePagamento[0].valor = JSON.parse(JSON.stringify(item.Valor));
        temp.formaDePagamentoCodigo = JSON.parse(JSON.stringify(this.formaDePagamento.formaDePagamentoId));

        this.baixasLista.push(temp);
      });

      this.movimentacaoService
        .baixarLista(this.baixasLista)
        .toPromise()
        .then(() =>
          this.finalizarPagamento(true, template),
          error =>
            this.finalizarPagamento(false, template)
        );
    }
  }

  finalizarPagamento(sucesso: boolean, template: TemplateRef<any>) {
    this.recebendo = false;
    this.pesquisar();

    if (!sucesso) {
      this.toastr.error('Erro no recebimento');
      this.fecharModalRecibo();
    } else {
      this.toastr.success('Recebimento realizado!');
      this.abrirModalRecibo(template);
    }
  }

  abrirModalRecibo(template: TemplateRef<any>) {
    // this.modalService.show(this.imprimirSelecionadosModal, Object.assign({}, { class: 'modal-lg modal-xl', id: 2 }));
    this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
    this.filtrarRecibos(this.lstModal);
  }

  fecharModalRecibo() {
    // this.modalService.hide(2);
    this.fecharModal();
    this.lstModal = [];
    this.baixasLista = [];
    this.lstRecibosBaixa = [];
    this.lstRecibos = [];
    this.lstRecibosTemp = [];
    this.totalSelecionados = this.lstModal.length;
  }

  filtrarRecibos(recibos: ReceberLista[]) {
    this.lstRecibosTemp = [];
    this.lstRecibosTemp = JSON.parse(JSON.stringify(recibos));

    const participantes = new Set();
    let i = 0;

    this.lstRecibosTemp.forEach((recibo) =>
      participantes.add(recibo.Cliente)
    );

    participantes.forEach((participante: string) => {
      this.lstRecibos.push(new ReceberLista());
      this.lstRecibos[i].Cliente = participante;
      this.lstRecibos[i].Valor = this.lstRecibosTemp
        .filter((recibo) => recibo.Cliente === participante)
        .reduce(
          (accumulator, currentValue) => accumulator + currentValue.Valor,
          0
        );
      i++;
    });
  }

  imprimirRecibo(index: number) {
    const newTab = window.open();
    newTab.location.href = window.location.href.split('#')[0] +
      '/#/recibo/R/' + this.lstReceber[index].Id;
  }

  imprimirSelecionados(index: number) {
    if (this.lstRecibosBaixa.length !== 0) {
      this.lstRecibosBaixa = [];
    }
    this.lstModal.forEach((item) => {
      if (this.lstRecibos[index].Cliente === item.Cliente) {
        const temp = new Baixa();
        item.DataRecebimento = this.dataRecebimento;
        temp.formaDePagamentoCodigo = String(
          this.formaDePagamento.formaDePagamentoId
        );
        temp.dataPagamento = this.dataRecebimento;
        temp.Tipo = 'R';
        temp.documentoId = item.Id;
        temp.valor = item.Valor;
        temp.formaDePagamento[0] = this.formaDePagamento;
        temp.formaDePagamento[0].valor = item.Valor;

        this.lstRecibosBaixa.push(temp);
      }
    });
    this.receberService.emitirRecibos(this.lstRecibosBaixa);
  }
}
